"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesSettings = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const uuid_1 = require("uuid");
const immutable_1 = require("immutable");
const lodash_1 = require("lodash");
const core_1 = require("companion-app-components/utils/core");
const categories_1 = require("companion-app-components/flux/categories");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
const transactionsTypes_1 = require("companion-app-components/flux/transactions/transactionsTypes");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const QButton_1 = __importDefault(require("components/QButton"));
const ResourceRegister_1 = __importDefault(require("components/ResourceRegister"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const QDialogs_1 = __importDefault(require("components/QDialogs"));
const DeleteDialog_1 = __importDefault(require("components/ResourceRegister/DeleteDialog"));
const TurnedInNotRounded_1 = __importDefault(require("@mui/icons-material/TurnedInNotRounded"));
const logger = (0, core_1.getLogger)('CategoriesSettings.js');
const styles = ({ palette, spacing, typography }) => ({
    sectionHeadline: {
        marginBottom: spacing(2),
        marginTop: spacing(4),
    },
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
        display: 'flex',
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: spacing(4),
        height: 'auto',
        marginRight: spacing(1),
        marginBottom: 4,
        color: palette.greyScaleDeprecated[2],
        verticalAlign: 'center',
        marginTop: 0,
    },
    iconSpacing: {
        marginRight: spacing(1),
    },
    categoriesContainer: {
        overflow: 'hidden',
        position: 'relative',
        minHeight: spacing(4),
        borderRadius: 20,
        border: `1px solid ${palette.divider}`,
    },
    noData: {
        display: 'block',
        width: '100%',
        textAlign: 'center',
        padding: `${spacing(4)} 0`,
    },
    bold: {
        fontWeight: typography.fontWeightMedium,
    },
});
const types = [
    { title: 'Income', value: 'INCOME' },
    { title: 'Expense', value: 'EXPENSE' },
];
// id, type, label, flex, editable, placeholder
const dataDictionary = (0, immutable_1.List)([
    { id: 'name',
        type: 'string',
        label: 'Category Name',
        flex: 3,
        editable: true,
        uniqueWith: ['parent'],
        placeholder: 'Name',
        hide: false,
    },
    { id: 'parent',
        type: 'CategoryField',
        label: 'Subcategory of',
        flex: 3,
        font: 'small',
        editable: true,
        defaultValue: '-',
        placeholder: 'None',
        hide: false,
    },
    { id: 'categoryType',
        type: 'select',
        choices: types,
        label: 'Type',
        flex: 2,
        editable: true,
        placeholder: 'Type',
        cascadeUpdate: true,
        hide: false,
    },
    { id: 'description',
        type: 'string',
        label: 'Description',
        flex: 4,
        font: 'small',
        editable: true,
        defaultValue: '-',
        placeholder: 'Description (optional)',
        hide: false,
    },
    { id: 'actions',
        type: 'actions',
        label: ' ',
        flex: 1,
        hide: false,
    },
]);
// ========== CACHE FOR SPEED ===========
let PARENT_CACHE = {};
function resetParentCache() {
    PARENT_CACHE = {};
}
function addToParentCache(key, value) {
    PARENT_CACHE[key] = value;
}
function parentCacheValue(key) {
    return PARENT_CACHE[key];
}
// ========== CACHE FOR SPEED ===========
function crawlList(coaNode, categories, flatten, level = 1) {
    const category = categories.get(coaNode.id);
    if (category && !category.isExcludedFromCategoryList) {
        let childData = null;
        if (coaNode.children) {
            childData = [];
            coaNode.children.forEach((node) => {
                childData = childData && childData.concat(crawlList(node, categories, flatten, level + 1));
            });
        }
        const parent = Number(category.parentId) ?
            parentCacheValue(category.parentId) || chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, { type: 'CATEGORY', id: category.parentId }, true) : '';
        addToParentCache(category.parentId, parent);
        const parentCatType = ['', '0'].includes(category.parentId) ? chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.NONE : chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY;
        const ret = [
            {
                id: category.id,
                name: category.name,
                description: category.description,
                categoryType: String(category.type),
                isExcludedFromBudgets: Boolean(category.isExcludedFromBudgets),
                isDeleted: category.isDeleted,
                parent,
                // if an object 'values' is included in the data record, the value specified for the given id
                // is used for the inputComponent instead of the string/number provided in the base object
                // (e.g. for 'parent', instead of the string above, we will use the coa record below)
                values: {
                    parent: { type: parentCatType, id: category.parentId },
                },
                // if the array property children is specified, then the objects in the array represent a hierarchical
                // section (child objects) of the parent
                children: childData,
                level,
            },
        ];
        return (flatten && childData) ? ret.concat(childData) : ret;
    }
    return [{ id: 0 }];
}
function makeLocalCategoriesData({ categories, chartOfAccounts, flatten }) {
    if (!categories) {
        return [];
    }
    resetParentCache();
    let data;
    if (chartOfAccounts) {
        let data2 = [];
        chartOfAccounts.forEach((coaNode) => {
            const ret = crawlList(coaNode, categories, flatten);
            data2 = data2.concat(ret);
        });
        data = ((0, immutable_1.List)(data2)).filter((x) => x.id !== 0);
    }
    return data;
}
const ID_NEW = '0';
const DEFAULT_REASSIGN_CATEGORY = {
    id: '0',
    type: 'Uncategorized',
};
function makeNewObject() {
    return ({
        values: {
            parent: { id: '0', type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.NONE },
        },
        parent: '',
        id: ID_NEW,
        name: '',
        categoryType: 'EXPENSE',
        description: '',
        isExcludedFromBudgets: false,
        isNewCategory: true,
        level: 1,
        children: null,
    });
}
const useStyles = (0, mui_1.makeStyles)()(styles);
const CategoriesSettings = (props) => {
    const { getItems, data, isLoading, setDialog, txnsProps, dialogAlert, createItem, updateItem, deleteItem, } = props;
    const { classes } = useStyles();
    const chartOfAccounts = (0, react_redux_1.useSelector)((state) => chart_of_accounts_1.chartOfAccountsSelectors.getChartOfAccountsTree(state));
    const makeData = (flatten = false) => {
        logger.log('**Categories new data', data);
        return makeLocalCategoriesData({
            categories: data,
            chartOfAccounts,
            flatten,
        });
    };
    const [categoriesData, setCategoriesData] = (0, react_1.useState)(makeData());
    const [flatData, setFlatData] = (0, react_1.useState)(makeData(true));
    const [reassignCategory, setReassignCategory] = (0, react_1.useState)(Object.assign({}, DEFAULT_REASSIGN_CATEGORY));
    (0, react_1.useEffect)(() => {
        getItems();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        setCategoriesData(makeData());
        setFlatData(makeData(true));
        setReassignCategory(Object.assign({}, DEFAULT_REASSIGN_CATEGORY));
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps
    /**
     * Checking for duplicate category name under its parent only, same as QWin.
     * @param {Object} category // It's the category being added/edited.
     * @param {Object} parentCategory // It's the parent of above category that contains all its children.
     * @returns Boolean
     */
    const checkForDuplicates = (category, parentCategory) => {
        if (!parentCategory.children) {
            const newData = flatData.filterNot((objCategory) => (objCategory.id === category.id || objCategory.level !== 1));
            const groupData = newData.groupBy((x) => x.name).mapKeys((x) => x.toLowerCase());
            return Boolean(groupData.get(category.name.toLowerCase().trim()));
        }
        return parentCategory.children.some((objCategory) => objCategory.level === parentCategory.level + 1 && objCategory.name.toLowerCase() === category.name.toLowerCase().trim());
    };
    const getCategoryByID = (id) => flatData.find((x) => x.id === id);
    const getCategoryDeep = (category, level = 1) => {
        let deep = level;
        if (category.children) {
            const childrenCount = [];
            deep += 1;
            category.children.forEach((cat, index) => {
                childrenCount[index] = cat.children ? getCategoryDeep(cat, deep) : deep;
            });
            deep = Math.max(...childrenCount);
        }
        return deep;
    };
    const handleRequestCreate = () => {
        const newIndex = categoriesData.findIndex((x) => x.id === ID_NEW);
        if (newIndex < 0) {
            const newData = categoriesData.unshift(makeNewObject());
            setCategoriesData(newData);
        }
    };
    const validateCategory = (category) => {
        let modal = null;
        // Check empty name
        if (!category.name || (category === null || category === void 0 ? void 0 : category.name.trim()) === '') {
            modal = {
                title: 'Unable to save category',
                body: 'You must specify a name for this category',
                callback: lodash_1.noop,
                buttons: ['Got it'],
            };
        }
        const parent = getCategoryByID(category.values.parent.id) || {};
        const { id: parentId = '', level: parentLevel = 0 } = parent;
        // Check duplicate category name under its parent only
        if (checkForDuplicates(category, parent)) {
            modal = {
                title: `${category.name} already exists.`,
                body: 'You need to use a unique name',
                callback: lodash_1.noop,
                buttons: ['Got it'],
            };
        }
        // Check maximum level
        const maxLevelAllowed = 16;
        const newCategoryLevel = getCategoryDeep(category) + parentLevel;
        if (newCategoryLevel > maxLevelAllowed) {
            modal = {
                title: 'Unable to save category',
                body: 'Maximum level exceed. You must specify a different subcategory.',
                callback: lodash_1.noop,
                buttons: ['Got it'],
            };
        }
        // Validate reassging same parent
        if (category.id === parentId) {
            modal = {
                title: 'Unable to save category',
                body: 'You must specify a different subcategory.',
                callback: lodash_1.noop,
                buttons: ['Got it'],
            };
        }
        if (modal) {
            dialogAlert(modal.title, modal.body, modal.callback, modal.buttons);
        }
        return !modal;
    };
    const removeNewItem = () => {
        const newData = categoriesData.filterNot((x) => x.id === ID_NEW);
        setCategoriesData(newData);
    };
    const handleSave = (category) => {
        var _a;
        if (validateCategory(category)) {
            const item = data.get(category.id) || categories_1.categoriesTypes.mkCategory();
            const parentType = category.values.parent.id !== '0' && ((_a = getCategoryByID(category.values.parent.id)) === null || _a === void 0 ? void 0 : _a.categoryType);
            const toSave = categories_1.categoriesTypes.mkCategory(Object.assign(Object.assign({}, category), { name: category.name.trim(), type: parentType || category.categoryType, parentId: category.values.parent.id, isDeleted: item.get('isDeleted'), knownCategoryId: item.get('knownCategoryId') }));
            if (category.id === ID_NEW) {
                core_1.tracker.track(core_1.tracker.events.categoryCreate, {
                    type: toSave.type,
                    level: category.level,
                    has_description: Boolean(category.description),
                });
                if (assert(toSave.name, `category name is required (name = '${toSave.name}') #bug-trap`)) {
                    createItem(toSave.merge({ id: undefined, clientId: (0, uuid_1.v4)().toUpperCase() }));
                }
                removeNewItem();
            }
            else {
                core_1.tracker.track(core_1.tracker.events.categoryEdit);
                updateItem(toSave);
            }
        }
    };
    // determine if this transaction has the given cat id in it
    const txnHasCat = (txn, cat) => {
        if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
            const ret = txn.split.items.find((item) => (item.coa && item.coa.id === cat.id));
            return Boolean(ret);
        }
        return (txn.coa && txn.coa.id === cat.id);
    };
    // TODO: remove the reference to the given tag id from the transaction
    // const removeTxnCat = (txn, cat) => {
    //   if (transactionsUtils.isSplitTxn(txn)) {
    //     return txn.setIn(['split', 'items'],
    //       txn.split.items.map((item) => item.coa && item.coa.id === cat.id ?
    //         item.set('coa', chartOfAccountsTypes.mkChartOfAccount()) : item));
    //   }
    //   return txn.set('coa', chartOfAccountsTypes.mkChartOfAccount());
    // };
    // reassign the reference to the given category to the transaction
    const reassignTxnCat = (txn, cat, newCat) => {
        var _a;
        const newCoa = chart_of_accounts_1.chartOfAccountsTypes.mkChartOfAccount({ id: newCat.id, type: newCat.type });
        if (!(txn instanceof transactionsTypes_1.CashFlowTransaction)) {
            if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
                return Object.assign(Object.assign({}, txn), { split: {
                        items: txn.split.items.map((item) => {
                            const txnWithChangedCoa = item instanceof transactionsTypes_1.CashFlowTransaction ? item.set('coa', newCoa) : Object.assign(Object.assign({}, item), { coa: newCoa });
                            return item.coa && item.coa.id === cat.id ? txnWithChangedCoa : item;
                        }),
                    } });
            }
            return Object.assign(Object.assign({}, txn), { coa: newCoa });
        }
        if (transactions_1.transactionsUtils.isSplitTxn(txn) && ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items)) {
            return txn.setIn(['split', 'items'], txn.split.items.map((item) => item.coa && item.coa.id === cat.id ?
                item.set('coa', newCoa) : item));
        }
        return txn.set('coa', newCoa);
    };
    const getTxnsToChange = (category) => {
        /*
         * Reassign references to this category in all transactions
         */
        const txnsToChangeParentCat = txnsProps.transactionsById.filter((txn) => txnHasCat(txn, category));
        /*
         * Reassign references to this category in all scheduled transaction models
         */
        const scheduledTxnsToChangeParentCat = txnsProps.scheduledTransactions.filter((stxn) => txnHasCat(stxn.transaction, category));
        const memTransactionToChangeParentCat = txnsProps.memTransactionsById.filter((payee) => txnHasCat(payee, category));
        if (category.children && category.children.length > 0) {
            let recursiveChildrenTxnsToChange = (0, immutable_1.Map)({});
            let recursiveChildrenSchTxnsToChange = (0, immutable_1.Map)({});
            let recursiveChildrenMemTxnsToChange = (0, immutable_1.Map)({});
            category.children.forEach((childCategory) => {
                const { txnsToChange, scheduledTxnsToChange, memTransactionToChange } = getTxnsToChange(childCategory);
                recursiveChildrenTxnsToChange = recursiveChildrenTxnsToChange.merge(txnsToChange);
                recursiveChildrenSchTxnsToChange = recursiveChildrenSchTxnsToChange.merge(scheduledTxnsToChange);
                recursiveChildrenMemTxnsToChange = recursiveChildrenMemTxnsToChange.merge(memTransactionToChange);
            });
            return {
                txnsToChange: recursiveChildrenTxnsToChange.merge(txnsToChangeParentCat),
                scheduledTxnsToChange: recursiveChildrenSchTxnsToChange.merge(scheduledTxnsToChangeParentCat),
                memTransactionToChange: recursiveChildrenMemTxnsToChange.merge(memTransactionToChangeParentCat),
            };
        }
        return {
            txnsToChange: txnsToChangeParentCat,
            scheduledTxnsToChange: scheduledTxnsToChangeParentCat,
            memTransactionToChange: memTransactionToChangeParentCat,
        };
    };
    const resetReassignCategory = () => {
        setReassignCategory(Object.assign({}, DEFAULT_REASSIGN_CATEGORY));
    };
    const deleteCategory = (category, hasTxns, txns, scheduledTxns, memTxns) => {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        let reassignCat = Object.assign({}, ((0, immutable_1.isImmutable)(reassignCategory) ? reassignCategory.toJS() : reassignCategory));
        let txnsToChange = txns;
        let scheduledTxnsToChange = scheduledTxns;
        let memTxnsToChange = memTxns;
        if (reassignCat.id === DEFAULT_REASSIGN_CATEGORY.id) {
            reassignCat = Object.assign(Object.assign({}, reassignCat), { type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED });
        }
        else {
            reassignCat = Object.assign(Object.assign({}, reassignCat), { type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY });
        }
        txnsToChange = txnsToChange.map((txn) => reassignTxnCat(txn, category, reassignCat)).toList();
        scheduledTxnsToChange = scheduledTxnsToChange.map((stxn) => stxn.set('transaction', reassignTxnCat(stxn.transaction, category, reassignCat))).toList();
        memTxnsToChange = memTxnsToChange.map((memTxn) => reassignTxnCat(memTxn, category, reassignCat)).toList();
        /* TODO when memorized transactions are enabled
         * Remove references to this tag in all memorized transactions
         */
        if (category.id !== reassignCat.id) {
            core_1.tracker.track(core_1.tracker.events.categoryDelete, { has_transactions_assigned: hasTxns });
            deleteItem(Object.assign(Object.assign({}, category), { isDeleted: true }));
            if (hasTxns) {
                if (txnsToChange.size > 0) {
                    txnsProps.batchTransactions(txnsToChange);
                }
                scheduledTxnsToChange.forEach((txn) => txnsProps.updateScheduledTransaction(txn));
                if (memTxnsToChange.size > 0) {
                    txnsProps.updateMemTransactions(memTxnsToChange);
                }
            }
        }
        else {
            setTimeout(() => {
                setDialog('Delete the Category', <>
            Unable to delete the category
            <strong className={classes.bold}> “{category.name}”</strong>. <br />
            Can&apos;t reassign to the same category.
          </>, () => {
                    handleDelete(category); // eslint-disable-line @typescript-eslint/no-use-before-define
                }, ['Got it']);
            }, 50);
        }
    };
    const handleDelete = (category) => {
        const { txnsToChange, scheduledTxnsToChange, memTransactionToChange } = getTxnsToChange(category);
        const hasTxns = txnsToChange.size > 0 || scheduledTxnsToChange.size > 0 || memTransactionToChange.size > 0;
        const deleteText = hasTxns ? 'Reassign & Delete' : 'Delete';
        const isLastCategory = categoriesData.size === 1;
        const hasChildren = category.children && category.children.length > 0;
        if (isLastCategory) {
            setDialog('Delete Category', 'We are unable to delete the last category', undefined, ['OK']);
        }
        else {
            setDialog('Delete the Category', <DeleteDialog_1.default category={category} hasTxns={hasTxns} hasChildren={hasChildren} txnsToChange={txnsToChange.size} scheduledTxnsToChange={scheduledTxnsToChange.size} memTxnsToChange={memTransactionToChange.size} reassignCategory={reassignCategory} setReassignCategory={setReassignCategory}/>, (dialog) => {
                if ([deleteText, 'Enter'].includes(dialog === null || dialog === void 0 ? void 0 : dialog.action)) {
                    deleteCategory(category, hasTxns, txnsToChange, scheduledTxnsToChange, memTransactionToChange);
                    resetReassignCategory();
                }
                if (['Close', 'Escape', 'Cancel'].includes(dialog === null || dialog === void 0 ? void 0 : dialog.action)) {
                    resetReassignCategory();
                }
            }, ['Cancel', deleteText]);
        }
    };
    return (<>
      <Grid_1.default className={classes.sectionHeadline} container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Typography_1.default variant="h5" className={classes.headlineText}>
          <TurnedInNotRounded_1.default className={classes.headlineIcon}/>
          Categories
        </Typography_1.default>
        <QButton_1.default id="categories-add-new-button" variant="contained" onClick={handleRequestCreate}>
          <Add_1.default className={classes.iconSpacing}/> CATEGORY
        </QButton_1.default>
      </Grid_1.default>
      <Grid_1.default className={classes.categoriesContainer} container>
        {categoriesData.size ?
            <ResourceRegister_1.default dataDictionary={dataDictionary.filterNot((x) => x.hide)} data={categoriesData} onSave={handleSave} onDelete={handleDelete} onRemoveNewItem={removeNewItem} getCategoryByID={getCategoryByID} setDialog={setDialog}/> :
            !isLoading &&
                <Typography_1.default className={classes.noData} component="p" variant="subtitle2">
              No categories available. Please click the button to add a new category
            </Typography_1.default>}
      </Grid_1.default>
    </>);
};
exports.CategoriesSettings = CategoriesSettings;
exports.default = (0, QDialogs_1.default)()(exports.CategoriesSettings);
